import { Component, OnInit, ViewChild, OnDestroy, Input, SimpleChanges } from '@angular/core';
import { Chart } from 'chart.js';
import { colors } from 'src/app/colors';
import { createChartConfig } from '../../reports-config';

@Component({
    selector: 'app-top-usage-chart',
    templateUrl: './top-usage-chart.component.html',
    styleUrls: ['./top-usage-chart.component.css'],
    standalone: false
})
export class TopUsageChartComponent implements OnInit, OnDestroy {
  @ViewChild('topUsageCanvas') topUsageCanvas: any;
  chart: Chart | null = null;
  @Input('chartData') chartData: { labels: string[], datasets: number[] } = { labels: [], datasets: [] };
  @Input('type') type: string = 'all';
  @Input('loading') loading: boolean = false;

  ngOnInit() { }

  ngAfterViewInit() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['chartData'] && this.chart) {
      this.updateChart();
    }

    if (changes['loading'] && !this.loading) {
      setTimeout(() => {
        this.initializeChart();
        this.updateChart();
      });
    }
  }

  initializeChart() {
    const ctx = this.topUsageCanvas.nativeElement.getContext('2d');
    const chartConfig: any = createChartConfig(this.type);

    if (this.chart) {
      this.chart.destroy();
    }

    this.chart = new Chart(ctx, chartConfig);
  }

  ngOnDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  }

  updateChart() {
    if (!this.chart) return;

    if (!this.chartData || !this.chartData.labels || this.chartData.labels.length === 0) {
      if (this.chart) {
        this.chart.data.labels = [];
        this.chart.data.datasets[0].data = [];
        this.chart.update();
      }
      return;
    }

    this.chart.data.labels = this.chartData.labels;
    this.chart.data.datasets[0].data = this.chartData.datasets;

    this.chart.update();
  }
}
